import type * as React from 'react';
import { getIntrinsicElementProps, slot, useArrowNavigationGroup } from '@fluentui/react-components';
import type { CopilotChatProps, CopilotChatState } from './CopilotChat.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render CopilotChat.
 *
 * The returned state can be modified with hooks such as useCopilotChatStyles_unstable,
 * before being passed to renderCopilotChat_unstable.
 *
 * @param props - props from this instance of CopilotChat
 * @param ref - reference to root HTMLElement of CopilotChat
 */
export const useCopilotChat_unstable = (props: CopilotChatProps, ref: React.Ref<HTMLDivElement>): CopilotChatState => {
  const arrowAttrs = useArrowNavigationGroup({ memorizeCurrent: true, unstable_hasDefault: true });

  const state: CopilotChatState = {
    components: {
      root: 'div',
    },
    root: slot.always(
      getIntrinsicElementProps('div', {
        ref,
        role: 'feed',
        ...props,
        ...arrowAttrs,
      }),
      { elementType: 'div' },
    ),
  };

  return state;
};
